import { isUndefinedOrNullOrEmpty } from 'common/utils/isUndefinedOrNullOrEmpty';

class OngCardDetailsController {
  constructor() {
    'ngInject';
  }

  hasDetails() {
    return !isUndefinedOrNullOrEmpty(this.details);
  }
}

export default OngCardDetailsController;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/features/mySolidarity/ongsList/ongCard/ongCardDetails/ongCardDetails.controller.js